import RGBA from '../../Fonts/RGBA'
import game from '../../Game/GameInstance'

let colors = {

  black : new RGBA(0)

};

export default class RoomElement
{

  constructor(room) {

    this.room = room;

  }

  scale(n) {

    return this.room.scale(n);

  }

  unscale(n) {

    return this.room.unscale(n);

  }

  roomWidth() {

    return this.room.width;

  }

  roomHeight() {

    return this.room.height;

  }

  getRoomTitle() {
    return this.room.data && this.room.data.name;
  }

  getRoomDescription() {
    return this.room.data && this.room.data.current_event;
  }

  getGameView() {
    return game.view;
  }

  debugBox(ctx,box) {

    ctx.beginPath();

    ctx.rect(this.scale(box.x), this.scale(box.y), this.scale(box.width), this.scale(box.height));

    ctx.strokeStyle = colors.black;
    ctx.stroke();

  }

  spreadInContainer(container, boxes, margin, verticalAlign)
  {
    let margins = [];

    if (!margin) { margin = 0; }

    if (typeof margin === 'number') {
      let i = boxes.length;
      while(i--) {
        margins.push(margin);
      }
    }
    else{
      margins = margin;
      let i = boxes.length - margins.length;
      while(i--) {
        margins.push(0);
      }
    }

    if (!verticalAlign) { verticalAlign = 'top';}

    let remainingWidth = container.width;
    let toSpread = [];
    let maxHeight = null;

    boxes.forEach((box, index) => {

      if (maxHeight === null || box.height > maxHeight) {
        maxHeight = box.height;
      }

      remainingWidth -= margins[index];

      if (box.width === null) {
        toSpread.push(box);
        return;
      }

      remainingWidth -= box.width;

    });

    toSpread.forEach(box => {
      box.width = remainingWidth / toSpread.length;
    });

    let x = container.x;

    container.height = maxHeight;

    boxes.forEach((box, index) => {

      box.x = x;

      switch(verticalAlign) {
        case 'top':
          box.y = container.y;
          break;
        case 'middle':
          box.y = container.y + (container.height - box.height) / 2;
          break;
        case 'bottom':
          box.y = container.y + (container.height - box.height);
          break;

      }

      x += box.width;
      x += margins[index];

    });

  }

  getSpeakers() {
    return this.room.speakers;
  }


}
